import { css } from '@emotion/core';
import { MediaQueries } from '../../../../styles/Grid';
import { colorsPalette, hexToRgba, shadows } from '../../../../styles/colors';
import { NAV_MAX_HEIGHT_SMALL_VIEWPORT } from '../../../../utils/constants';
import { typography } from '../../../../styles/typography';

const BUTTON_SMALL = 64;

export const cardColumn = css({
  marginBottom: 32,
});

export const refreshButton = showMap =>
  css(typography.effra16, {
    background: colorsPalette.white,
    display: 'inline-block',
    height: BUTTON_SMALL,
    left: 0,
    paddingLeft: 16,
    position: 'relative',
    textAlign: 'left',
    textTransform: 'none',
    top: 0,
    width: `calc(100% - ${BUTTON_SMALL}px)`,
    zIndex: '1',

    [MediaQueries.mdAndUp]: {
      alignItems: 'center',
      borderRadius: 2,
      boxShadow: shadows.shadow40,
      display: showMap ? 'flex' : 'none',
      height: 'auto',
      left: '50%',
      padding: '11px 22px 13px',
      position: 'absolute',
      top: '20px',
      transform: 'translateX(-50%)',
      width: 'auto',
    },
  });

export const filterSmall = css({
  width: BUTTON_SMALL,
  height: BUTTON_SMALL,
  position: 'relative',
  background: colorsPalette.white,
  border: 'none',
  borderLeft: `1px solid ${colorsPalette.grey10}`,
  top: 0,
  right: 0,
  zIndex: 1,
});

export const iconFilter = css({
  fontSize: 17,
});

export const grid = css({
  marginBottom: 64,
  [MediaQueries.md]: {
    marginBottom: 96,
  },
  [MediaQueries.lgAndUp]: {
    marginBottom: 160,
  },
});

export const richFilteringWrap = css({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: 32,
});

export const cardsWrap = showMap =>
  css({
    [MediaQueries.md]: {
      display: showMap ? 'none' : 'block',
    },
  });

export const mapWrap = showMap =>
  css({
    borderTop: `1px solid ${colorsPalette.grey10}`,
    height: `calc(100vh - ${NAV_MAX_HEIGHT_SMALL_VIEWPORT}px)`,
    left: 0,
    paddingLeft: 0,
    paddingRight: 0,
    position: 'fixed',
    top: 0,
    transform: showMap
      ? `translateY(${NAV_MAX_HEIGHT_SMALL_VIEWPORT}px)`
      : `translateY(calc(100% + ${NAV_MAX_HEIGHT_SMALL_VIEWPORT}px))`,
    zIndex: 1,

    [MediaQueries.mdAndUp]: {
      borderTop: 0,
      height: '100vh',
      position: showMap ? 'relative' : 'absolute',
      transform: 'translateY(0)',
      visibility: showMap ? 'visible' : 'hidden',
    },

    [MediaQueries.lgAndUp]: {
      position: showMap ? 'sticky' : 'absolute',
      transform: 'translateY(0%)',
    },
  });

export const mapContainer = css({
  height: `calc(100% - ${BUTTON_SMALL}px)`,
  left: 0,
  position: 'relative',
  width: '100%',

  [MediaQueries.mdAndUp]: {
    height: '100%',
  },

  '.zoom-in-control': {
    marginLeft: 16,
    marginTop: 16,
  },

  '.zoom-out-control': {
    marginLeft: 16,
  },
});

export const loadingVisibility = isLoading =>
  css({
    visibility: isLoading ? 'hidden' : 'visible',
  });

export const refreshIcon = css({
  marginLeft: 8,
});

export const locationPlaceholder = css({
  border: `1px solid ${hexToRgba(colorsPalette.brown40, 0.5)}`,
  borderBottomLeftRadius: 32,
  minHeight: 400,
  position: 'relative',
});

export const searchAnimationCss = css({
  border: 'none',
  left: '50%',
  position: 'absolute',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
});

export const infiniteScrollReference = css({
  bottom: 300,
  height: 400,
  left: 0,
  position: 'absolute',
  width: 300,
  zIndex: -1,
});
